import { render, staticRenderFns } from "./page-feedback-view.vue?vue&type=template&id=acc35344&scoped=true&"
import script from "./page-feedback-view.vue?vue&type=script&lang=js&"
export * from "./page-feedback-view.vue?vue&type=script&lang=js&"
import style0 from "./page-feedback-view.vue?vue&type=style&index=0&id=acc35344&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acc35344",
  null
  
)

export default component.exports